export { default as Loader } from './component';